import { Typography } from "@mui/material";

export default function TitleCard({children, ...props}) {
    
    return(
        <Typography sx={{
            fontWeight:"bold",
            fontSize:"1.0rem",
            color:"black",
        }} {...props}>
            {children}
        </Typography>
    )
}